import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { CmsLandingComponent } from './cms-landing.component';

export const LANDING_PREFIX = 'l';

export function cmsPageLandingUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (url.length > 0 && url[0].path === LANDING_PREFIX) {
    return { consumed: url };
  }
  return null;
}

const cmsRoutes: Routes = [
  {
    path: '',
    component: CmsLandingComponent,
    data: {
      pageAnalytics: {
        env_template: 'channels'
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(cmsRoutes)],
  exports: [RouterModule]
})
export class CmsLandingRoutingModule {}
